import React from "react";
import { Button } from "react-bootstrap";

export const CustomButton = ({ value, className = "", ...props }) => {
  return (
    <Button
      {...props}
      variant={props.variant || "primary"}
      className={`w-100 ${className}`}
      type={props.type || "button"}
    >
      {value || "Continue"}
    </Button>
  );
};
